import React from 'react'

import { Box, Text, WizardStepRenderParams, useOnNext } from '@factorialco/deprecated-design-system'
import { RichTextEditor, RichTextEditorHandle } from '@factorialco/f0-react/dist/experimental'

import TextArea from 'modules/core/components/TextArea'
import useRichTextEditor from 'modules/core/hooks/useRichTextEditor'
import { track } from 'modules/core/lib/Tracking'
import i18n from 'modules/core/lib/i18n'

import { WizardData } from 'modules/trainings/components/Shared/WizardComponent/types'

type Props = {
  amplitudeEventNext: string
}
export const CommentsStep = ({
  data,
  onDataChanged,
  amplitudeEventNext,
}: WizardStepRenderParams<WizardData> & Props) => {
  const onCommentChange = (comments: string) => {
    onDataChanged({ ...data, comments: comments })
  }
  const { editorConfig, canUseRichTextEditor, loading: richTextEditorLoading } = useRichTextEditor()
  const commentsRichTextEditorRef = React.useRef<RichTextEditorHandle>(null)

  useOnNext(() => {
    track(amplitudeEventNext, {
      from: 'my_request',
    })
  })

  return (
    <Box width="s600" gap="s24">
      <Text size="400" weight="medium" color="grey1000">
        {i18n.t('trainings.training_requests.create.additional_info.title')}
      </Text>
      {richTextEditorLoading ? (
        <RichTextEditor.Skeleton />
      ) : canUseRichTextEditor ? (
        <RichTextEditor
          ref={commentsRichTextEditorRef}
          {...editorConfig}
          onChange={(value) => onDataChanged({ ...data, comments: value?.value ?? '' })}
          placeholder={i18n.t('trainings.training_requests.create.additional_info.placeholder')}
          initialEditorState={{ content: data.comments || '' }}
          title={i18n.t('trainings.training_requests.create.additional_info.description')}
          height="sm"
        />
      ) : (
        <TextArea
          value={data.comments}
          label={i18n.t('trainings.training_requests.create.additional_info.description')}
          placeholder={i18n.t('trainings.training_requests.create.additional_info.placeholder')}
          onChange={onCommentChange}
        />
      )}
    </Box>
  )
}
